import { db } from "../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
const GetPropertiesForLead = async (leadIdToGetProperties) => {
  /**
   * input: null
   * output: lead properties document / collection
   * description: get lead properties / get documents
   */

  try {
    const propertyCollection = await collection(db, "properties");

    const q = query(
      propertyCollection,
      where("lead", "==", leadIdToGetProperties)
    );
    const leadPropertySnapshot = await getDocs(q);

    const PropertiesForLead = [];

    leadPropertySnapshot.forEach((deal) =>
      PropertiesForLead.push({ id: deal.id, ...deal.data() })
    );

    return PropertiesForLead;
  } catch (error) {
    console.log(error);
  }
};

export default GetPropertiesForLead;
